import { useState } from "react";

const usePasswordToggle = (initialType = "password") => {
  const [type, setType] = useState(initialType);
  const [icon, setIcon] = useState(true)

  const toggleType = () => {
    setType((prevType) => (prevType === "password" ? "text" : "password"));
    setIcon(!icon)
  };

  return {
    type,
    toggleType,
    icon
  };
};

export default usePasswordToggle;
